<template>
  <div
    :class="{
      'where-buy': true,
      '--full': fullVersion,
      '--in-pop-up': !fullVersion,
    }"
  >
    <h2 v-if="fullVersion" class="where-buy__title">Где купить</h2>
    <div class="where-buy__content">
      <h2 v-if="!fullVersion" class="where-buy__title-in">Где купить</h2>
      <img
        class="_close"
        src="../assets/img/where-buy/close.svg"
        @click="close()"
      />
      <img
        class="_bg"
        :src="
          require('../assets/img/where-buy/bg' +
            (!fullVersion ? '-pop-up' : '') +
            '.svg')
        "
      />
      <div class="where-buy__logos grid-view --columns-4">
        <a href="https://samokat.ru/" class="--samokat"
          ><img src="../assets/img/where-buy/logo 1.svg"
        /></a>
        <a
          href="https://lavka.yandex.ru/search?text=tuc"
          class="--lavka"
          target="_blank"
          ><img src="../assets/img/where-buy/logo 2.svg"
        /></a>
        <a
          href="https://www.ozon.ru/category/pechene-kreker-9383/tuc-136780676/"
          class="--ozon"
          target="_blank"
          ><img src="../assets/img/where-buy/logo 3.svg"
        /></a>
        <a
          href="https://sbermarket.ru/multisearch?q=тук"
          class="--sber"
          target="_blank"
          ><img src="../assets/img/where-buy/logo 4.svg"
        /></a>
        <a
          href="https://www.perekrestok.ru/cat/search?search=tuc"
          class="--perek"
          target="_blank"
          ><img src="../assets/img/where-buy/logo 5.svg"
        /></a>
        <a href="https://dostavka.5ka.ru/" class="--five" target="_blank"
          ><img src="../assets/img/where-buy/logo 6.svg"
        /></a>
        <a
          href="https://dostavka.magnit.ru/express/search?q=tuc&page=1"
          class="--magn"
          ><img src="../assets/img/where-buy/logo 7.svg"
        /></a>
        <a
          href="https://online.lenta.com/search/tuc"
          class="--lenta"
          target="_blank"
          ><img src="../assets/img/where-buy/logo 8.svg"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhereBuy",
  props: {
    fullVersion: Boolean,
  },
  methods: {
    close() {
      this.$emit("close")
    },
  },
}
</script>

<style lang="scss">
.where-buy {
  &.--full {
    background-color: $color-yellow;
    padding: 68px 0 157px;
  }
  &.--in-pop-up {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .where-buy__content {
      width: 1187px;
      height: 473px;
      padding-top: 40px;
    }
    ._close {
      display: inline-block;
    }
  }
  overflow: hidden;
  &__title {
    font-family: $font-peach;
    font-size: 11.2rem;
    text-transform: uppercase;
    text-align: center;
    color: $color-blue;
    transform: rotate(-4deg);
    margin-bottom: 20px;
  }
  &__title-in {
    font-family: $font-peach;
    font-size: 11.2rem;
    text-transform: uppercase;
    text-align: center;
    color: $color-blue;
    transform: rotate(-4deg);
    margin-bottom: 28px;
    z-index: 5;
    position: relative;
  }
  &__content {
    position: relative;
    padding: 105px 54px;
    max-width: 1307px;
    min-height: 443px;
    margin: 0 auto;
    ._close {
      position: absolute;
      right: 50px;
      top: 0px;
      cursor: pointer;
      z-index: 5;
      display: none;
    }
    ._bg {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      z-index: 0;
    }
  }
  &__logos {
    position: relative;
    gap: 24px;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #efefef;
      border-radius: 32px;
      min-height: 108px;
    }
    .--samokat {
      background-color: #ff335f;
    }
    .--ozon {
      background-color: #005bff;
    }
    .--five {
      background-color: #008f33;
    }
    .--lenta {
      background-color: #174d9e;
    }
  }
}

@include respond-to("small") {
  .where-buy__content {
    margin: 0 40px;
    padding: 85px 46px;
    min-height: 390px;
  }
  .where-buy__title {
    font-size: 8.6rem;
  }
  .where-buy__logos {
    gap: 20px;
    a {
      min-height: 98px;
      img {
        max-width: 140px;
      }
    }
  }
}

@include respond-to("smartphone-plus") {
  .where-buy {
    border-radius: 48px 48px 0 0;
    margin-top: -48px;
    &.--full {
      background-color: $color-yellow;
      padding: 85px 0 128px;
    }
    &.--in-pop-up {
      margin-top: 0;
      .where-buy__content {
        height: auto;
        width: auto;
      }
    }

    &__title {
      font-size: 4.4rem;
      margin-bottom: 28px;
    }
    &__title-in {
      font-size: 4.7rem;
      margin-bottom: 28px;
    }
    &__content {
      padding: 48px 18px;
      max-width: 100%;
      min-height: 0;
      margin: 0 20px;
      background-color: #fff;
      border-radius: 32px;
      ._bg {
        display: none;
      }
      ._close {
        right: 12px;
        top: 12px;
        width: 38px;
      }
    }
    &__logos {
      grid-template-columns: 1fr 1fr !important;
      gap: 9px;
      a {
        min-height: 98px;
        padding: 6px 16px;
        box-sizing: border-box;
        img {
          width: 90%;
        }
      }
    }
  }
}
</style>
